function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bce537f2-b954-402c-8135-21aaaa099ff9",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M30.11,49.74c-11,0-21.31-6.57-29-18.5a1.08,1.08,0,0,1,0-1.15c7.71-11.93,18-18.5,29-18.5s21.32,6.57,29,18.5a1,1,0,0,1,0,1.14C51.44,43.17,41.13,49.74,30.11,49.74Zm0-36c-10,0-19.43,5.91-26.66,16.63l-.23.33.23.34c7.24,10.72,16.71,16.62,26.66,16.62S49.54,41.73,56.78,31l.23-.34-.23-.33C49.54,19.61,40.07,13.71,30.11,13.71Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.13,44.2A13.53,13.53,0,0,1,17.55,25.66a1.09,1.09,0,0,1,.86-.66h.1a1.09,1.09,0,0,1,.89.45,4,4,0,1,0,5.51-5.51,1,1,0,0,1-.45-1,1,1,0,0,1,.65-.86,13.53,13.53,0,1,1,5,26.1ZM18.82,29a11.42,11.42,0,1,0,9.57-9.58l-.86.14.43.75a6.07,6.07,0,0,1-8.26,8.25L19,28.1Z"
})));

var SvgIconEyeOpen = function SvgIconEyeOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEyeOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_eye-open.0c65946c.svg";
export { ForwardRef as ReactComponent };